export default __webpack_public_path__ + "static/media/avatar_tommy_pyper3.9697a4c0.mp3";